import { PRODUCT } from "./products";

export const SYMPTOMS = {
    FACIAL_HAIR: "Facial hair",
};

export const QUIZ_CATEGORIES = {
    OESTRA_CREAM: PRODUCT.OESTRA_CREAM,
    OESTRA_CREAM_REDESIGN: "oestra-cream-redesign",
    OESTRA_CREAM_REDESIGN_SENSITIVE: "oestra-cream-redesign-sensitive-questions-2410",
    OESTRA_CREAM_REDESIGN_SUPPORT: "oestra-cream-redesign-support-screen-2547",
    OESTRA_CREAM_REDESIGN_DETAILS: "oestra-pre-purchase-redesign-2642",
    FACE_CREAM: PRODUCT.FACE_CREAM,
    FACE_CREAM_REDESIGN: "face-cream-redesign",
    DOSAGE_ADJUSTMENT: PRODUCT.DOSAGE_ADJUSTMENT,
    DOSAGE_ADJUSTMENT_REDESIGN: "dosage-adjustment-redesign",
    OESTRA_ENDO_PRE_PURCHASE: PRODUCT.OESTRA_ENDO_PRE_PURCHASE,
    OESTRA_POSTPARTUM_PRE_PURCHASE: PRODUCT.OESTRA_POSTPARTUM_PRE_PURCHASE,
    OESTRA_MENOPAUSE_PRE_PURCHASE: "menopause",
    OESTRA_CREAM_UPSELL_SHORT: "oestra-upsell-short",
    FACE_CREAM_UPSELL_SHORT: "face-cream-upsell-short",
    LIBIDA: PRODUCT.LIBIDA,
    LIBIDA_REDESIGN: "libida-redesign",
    NAD: PRODUCT.NAD,
    OESTRA_CREAM_REDESIGN_REVIEWS_TOP: "oestra-cream-redesign-2785-top",
    OESTRA_CREAM_REDESIGN_REVIEWS_WHITE: "oestra-cream-redesign-2785-white",
    OESTRA_CREAM_REDESIGN_REVIEWS_YELLOW: "oestra-cream-redesign-2785-yellow",
    BIOIDENTICAL_HRT: "bioidentical-web-2918",
} as const;

export const BIOIDENTICAL_HRT_QUIZ = {
    queryParam: "hormoneTherapy",
    sourceQueryParam: "quizSource",
    lpQuizViewedStorageKey: "bioidentical-hrt-lp-quiz-viewed",
    questionName: "have_you_used_hormone_therapy_before",
    source: {
        PQP: "pqp",
        QUIZ: "quiz",
    },
    answers: {
        CURRENT: {
            key: "current",
            value: "Yes – currently on it",
        },
        PAST: {
            key: "past",
            value: "Yes – in the past",
        },
        NEVER: {
            key: "never",
            value: "no-never",
        },
    },
} as const;

export type BioidenticalHrtAnswerKey =
    typeof BIOIDENTICAL_HRT_QUIZ.answers[
        keyof typeof BIOIDENTICAL_HRT_QUIZ.answers
    ]["key"];

export const markBioidenticalLpQuizViewed = () => {
    if (typeof sessionStorage === "undefined") return;
    sessionStorage.setItem(BIOIDENTICAL_HRT_QUIZ.lpQuizViewedStorageKey, "1");
};

export const consumeBioidenticalLpQuizViewed = (): boolean => {
    if (typeof sessionStorage === "undefined") return false;
    const { lpQuizViewedStorageKey } = BIOIDENTICAL_HRT_QUIZ;
    if (sessionStorage.getItem(lpQuizViewedStorageKey) !== "1") return false;
    sessionStorage.removeItem(lpQuizViewedStorageKey);
    return true;
};

/** Quizzes a patient who already finished an Oestra quiz skips. */
export const SKIPPABLE_QUIZ_CATEGORIES: string[] = [
    QUIZ_CATEGORIES.LIBIDA,
    QUIZ_CATEGORIES.FACE_CREAM,
    QUIZ_CATEGORIES.FACE_CREAM_REDESIGN,
];

export const QUIZ_REDESIGN_CATEGORIES = {
    [QUIZ_CATEGORIES.OESTRA_CREAM]: QUIZ_CATEGORIES.OESTRA_CREAM_REDESIGN,
    [QUIZ_CATEGORIES.FACE_CREAM]: QUIZ_CATEGORIES.FACE_CREAM_REDESIGN,
    [QUIZ_CATEGORIES.LIBIDA]: QUIZ_CATEGORIES.LIBIDA_REDESIGN,
} as const;
